module.exports = __webpack_public_path__ + "img/Ronnie_Professional.c7e42904.jpg";